import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  slider: {
    "& .slick-list": {
      ...shorthands.padding("0px !important"),
    },
  },
  slickDots: {
    display: "none",
    justifyContent: "center",
    listStyleType: "none",
    ...shorthands.gap("16px"),
    ...shorthands.padding("12px", "4px"),

    "@media (max-width: 953px)": {
      display: "flex",
    },
  },

  dot: {
    ...shorthands.padding(0),
    ...shorthands.border("1px", "solid", "transparent"),
    ...shorthands.borderRadius("4px"),
    backgroundColor: "#b0beff",
    display: "block",
    height: "8px",
    width: "8px",
  },

  active: {
    backgroundColor: tokens.colorBrandForeground1,
    ...shorthands.borderRadius("28px"),
    width: "36px",
  },
});
